import { Button } from 'components/common'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { PAGE_DASHBOARD } from 'utils/constants'

const NotFound = () => {
  const navigate = useNavigate()

  const backToHome = () => {
    navigate(PAGE_DASHBOARD.path)
  }

  return (
    <>
      <Helmet>
        <title>ORMS Not Found</title>
      </Helmet>
      <main className="mx-auto max-w-7xl px-3">
        <div className="flex h-screen w-full flex-col items-center justify-center">
          <h1 className="text-8xl font-bold text-error">404</h1>
          <h2 className="mb-3 mt-1 text-2xl font-semibold">Page Not Found</h2>
          <Button
            buttonText="Back to home"
            variant="outline"
            size="small"
            className="w-32"
            type="button"
            onClick={backToHome}
          />
        </div>
      </main>
    </>
  )
}

export default NotFound
